import React from 'react';
import ReactDOM from "react-dom/client";
import { I18nextProvider } from "react-i18next";
import i18n from './locale/i18n';
import App from './app/App';
import { ShellThemeProvider } from '@sede-enterprise/shell-ds-react-framework';
import { ToastProvider } from 'rc-toastr';
import 'rc-toastr/dist/index.css'
const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
    
    <React.StrictMode>
        <I18nextProvider i18n={i18n}>
            <ShellThemeProvider theme={'light'}>
                <ToastProvider>
                    <App/>
                </ToastProvider>
            </ShellThemeProvider>
        </I18nextProvider>
    </React.StrictMode> 
);